import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface AuthLayoutProps {
  children: ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-background via-background to-primary/5">
      {/* Main Content - Logo + Form grouped and centered */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          {/* Logo */}
          <div className="mb-8 text-center">
            <img 
              src="/bluelux-logo.png" 
              alt="BlueLux" 
              className="h-12 sm:h-10 mx-auto" 
            />
          </div>
          
          {/* Form Content */}
          {children}
        </div>
      </div>
      
      {/* Footer */}
      <footer className="py-6 border-t border-border/50">
        <div className="container max-w-md mx-auto px-4">
          <div className="text-center text-sm text-muted-foreground space-y-2">
            <p>Need help? Contact support@bluelux.com</p>
            <div className="flex justify-center gap-4">
              <a href="https://bluelux.com" className="hover:text-primary transition-colors">
                ← Back to Website
              </a>
              <span>|</span>
              <span>© 2025 BlueLux</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
